import { webApi } from "../../../../core/http/httpThunks";

export const deleteTransportFeeApi = (userId: string, id: number) =>
  webApi<string>({
    method: "DELETE",
    url: "clearing/deltransfee",
    params: {
      userId,
      id,
    },
  });

export default deleteTransportFeeApi;
